module.exports = __webpack_public_path__ + "static/media/icon1.376734bf.jpg";